var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPaste = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.928 4.285h-2.142v1.072h2.143v1.071h1.07V5.357a1.072 1.072 0 0 0-1.07-1.072ZM13.928 7.5H15v3.214h-1.072V7.5ZM13.929 13.928h-1.072v1.071h1.072A1.071 1.071 0 0 0 15 13.928v-2.143h-1.071v2.143ZM10.714 9.643V1.07A1.072 1.072 0 0 0 9.643 0H1.07A1.071 1.071 0 0 0 0 1.071v8.572a1.072 1.072 0 0 0 1.071 1.071h8.572a1.072 1.072 0 0 0 1.071-1.071ZM1.071 1.07h8.572v8.572H1.07V1.07ZM8.572 13.929h3.214V15H8.572V13.93ZM5.357 11.785H4.286v2.143a1.071 1.071 0 0 0 1.071 1.071H7.5v-1.071H5.357v-2.143Z",
  fill: "currentColor"
})));

export default SvgPaste;